import React, { useRef } from 'react';
import { useGLTF } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';

const CarModel = () => {
  const { scene } = useGLTF('/media/bmw_m6_gran_coupe.glb'); // Path to your .glb file
  const carRef = useRef();

  // Use useFrame to make the car rotate slowly
  useFrame(() => {
    if (carRef.current) {
      carRef.current.rotation.y += 0.001; // Rotate the car around the Y-axis
    }
  });

  return <primitive ref={carRef} object={scene} scale={1.5} />;
};

export default CarModel;
